import { verificationNotificationTypes } from 'constants/verificationNotificationType';

export const getVerificationNotificationType = (notifications) => {
    const notificationItem = notifications.find(notification => verificationNotificationTypes.includes(notification.type));

    return notificationItem ? notificationItem.type : '';
}